import mustache from 'mustache';
export function customZPL(data, template) {
    const customZPLTemplate = template.find(t => t.hNodeType === 'CustomZplContent');
    if (!customZPLTemplate || !customZPLTemplate.customZpl) {
        return '';
    }
    const rendered = mustache.render(customZPLTemplate.customZpl, data);
    return rendered;
}
